const video_launcher = $('.yt-launcher, .vimeo-launcher');

if (video_launcher.length) {
  $(document).on('click', '.yt-launcher, .vimeo-launcher', function () {
    const $container = $(this);

    const overlay = $container.find('.video-overlay-title');
    const iframe  = $container.find('iframe');
    const img     = $container.find('img');

    let srcUrl = iframe.data('src');

    if ($container.hasClass('vimeo-launcher')) {
      srcUrl += '?autoplay=1&muted=1';
    } else {
      srcUrl += '?rel=0&controls=1&showinfo=0&autoplay=1&mute=1';
    }

    iframe.attr('src', srcUrl);
    overlay.hide();
    img.hide();
    iframe.addClass('show');
  });
}
